module.exports = __webpack_public_path__ + "static/media/mona-lisa.228c4fc5.jpeg";